import { graphql } from 'gql/generated'

export const GET_OPERATIONAL_COSTS = graphql(`
  query GetOperationalCosts($input: OperationalCostsInput, $pagination: PaginationV2) {
    operationalCosts(input: $input, pagination: $pagination) {
      total
      items {
        id
        stateCode
        vehicleCapacity
        vehicleType
        settings {
          costs {
            fixedCost
            durationCost
            costPerKm
            costPerDriver
          }
          factors {
            airConditioning
            baseDistance
            perKm
            redZone
            duration {
              start
              end
              value
            }
          }
        }
      }
    }
  }
`)
